import React from 'react';

import { Icon } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { Box, BoxProps } from 'components/ui';
import UnstyledButton from 'components/unstyled-button';
import { useIsMobileBreakpoint } from 'hooks/use-media-query';
import { t } from 'state/intl/translations';
import { getDesignToken, spacing } from 'styles/constants';

import { DropdownArrow } from './dropdown-arrow';

const DropdownContainer = ({ style, ...props }: BoxProps) => {
  const isMobile = useIsMobileBreakpoint();

  return (
    <Box
      {...props}
      style={[styles.dropdownContainer, !isMobile && styles.dropdownContainerDesktop, style]}
    />
  );
};

const dropdownArrowSize = {
  mobile: {
    height: 10,
    width: 5.71,
  },
  desktop: {
    height: 14,
    width: 8,
  },
};

const dropdownArrowOrientation = {
  initialAngleDeg: 90,
  finalAngleDeg: -90,
};

export const DropdownIndicator: React.FC<React.PropsWithChildren<{
  isOpen: boolean;
  isDisabled?: boolean;
}>> = ({ isOpen, isDisabled = false }) => (
  <DropdownContainer>
    <DropdownArrow
      open={isOpen || false}
      disabled={isDisabled || false}
      size={dropdownArrowSize}
      orientation={dropdownArrowOrientation}
    />
  </DropdownContainer>
);

const ClearButton = UnstyledButton.withConfig({
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  margin: 0,
  padding: {
    base: '$2',
    md: '$3',
  },
  paddingRight: {
    md: '$2',
  },
});

const Clear = Icon.withConfig({
  size: { base: '$4', md: '$5' },
});

export const ClearIndicator: React.FC<React.PropsWithChildren<{
  isDisabled?: boolean;
  onPress: () => void;
}>> = ({ isDisabled = false, onPress }) => {
  return (
    <ClearButton accessibilityLabel={t('clearFilter')} onPress={onPress}>
      <Clear
        variant="cancel"
        color={isDisabled ? getDesignToken('icon-disabled') : getDesignToken('icon-default')}
      />
    </ClearButton>
  );
};

export const IndicatorSeparator = ({ style, ...props }: BoxProps) => (
  <Box {...props} style={[styles.indicatorSeparator, style]} />
);

const styles = StyleSheet.create({
  dropdownContainer: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
    padding: spacing.$2,
  },
  dropdownContainerDesktop: {
    padding: spacing.$3,
  },
  indicatorSeparator: {
    alignSelf: 'stretch',
    backgroundColor: getDesignToken('border-color-default'),
    marginHorizontal: 0,
    marginVertical: spacing.$1,
    width: 1,
  },
});
